/**
 * Función que abre una nueva pestaña con el FAQ de la aplicación
 */
export function navigateToFaq(): void {
  window.open(
    " https://www.uanl.mx/preguntas-frecuentes/?lang=Aplicaciones+m%C3%B3viles&palabra=Asiste+Seguro&searchsubmit=",
    "_blank"
  );
}
